<div class="tile-progress bg-white text-left col-lg-12" style="padding: 0px;">
    <div>
      <div class="card-header">Framework Configuration</div>
      <div class="card-body">
        <table class="table table-bordered">
          <tr>
            <td class="col-lg-2" style="padding-left: 18px;">Select payment Gateway</td>
            <td z>
              <label class="switch" style="margin-top: 5px;" >
                <input type="checkbox" [(ngModel)]="paymentGateway">
                <div class="slider">
                  <span class="on" style="color:white;font-size: medium;left:40%;">PayuMoney</span><span class="off"
                    style="color:white;font-size: medium;left:55%">RazorPay</span>
                </div>
              </label>
            </td>
          </tr>
        </table>
      </div>
      <div class="col-lg-4 card-footer" style="margin-bottom: 10px;text-align: center;padding-left: 54px;">
        <button class=" btn" style="background-color: rgb(87,200,231);color:white" (click)="save()">Save</button>
      </div>
    </div>
</div>